import { forwardRef } from "react";

import { useIsDesktop } from "@hooks/layout";

import * as Styled from "../styles";

type TChoiceButton = {
  title: string;
  description: string;
  onClick: () => void;
};

export type TButtons = {
  firstButton: TChoiceButton;
  secondButton: TChoiceButton;
};

type TChoiceButtons = {
  buttons: TButtons;
};

export const ChoiceButtons = forwardRef<HTMLDivElement, TChoiceButtons>((props, ref) => {
  const buttons = Object.values(props.buttons);
  const isDesktop = useIsDesktop();

  return (
    <Styled.ChoiceButtonsWrapper ref={ref} $isDesktop={isDesktop}>
      {buttons.map(({ description, title, onClick }, index) => (
        <Styled.ChoiceButton key={index} onClick={onClick} $isDesktop={isDesktop}>
          <Styled.RadioCircle />
          <Styled.ChoiceContent>
            <Styled.ChoiceTitle>{title}</Styled.ChoiceTitle>
            <Styled.ChoiceDesc>{description}</Styled.ChoiceDesc>
          </Styled.ChoiceContent>
        </Styled.ChoiceButton>
      ))}
    </Styled.ChoiceButtonsWrapper>
  );
});
